import styled from 'styled-components';

export const InformationHowToMeasureModalStyled = styled.div``;
